import { RouteType } from '@/lib/route';
import TemplateSetupComponent from '.';

const SettingsTemplateSelectedRoutes: RouteType = {
  path: '/settings/template/:templateId',
  component: TemplateSetupComponent,
};

export interface TenantSettingsTemplateParamTypes {
  templateId: string;
}

export default SettingsTemplateSelectedRoutes;
